export default function DailyWisdom() {
  return (
    <section className="py-20 bg-gradient-to-br from-amber-900 via-orange-800 to-amber-900 relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Icon */}
          <div className="w-20 h-20 mx-auto mb-8 bg-white/10 rounded-full flex items-center justify-center">
            <i className="ri-book-open-line text-4xl text-amber-100"></i>
          </div>

          {/* Title */}
          <h2 
            className="text-3xl sm:text-4xl font-bold text-white mb-8"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            오늘의 법구경
          </h2>

          {/* Quote */}
          <blockquote className="mb-8">
            {/* 한문 원문 */}
            <p 
              className="text-xl sm:text-2xl text-amber-100 leading-relaxed mb-4"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              若以色見我 以音聲求我<br />
              是人行邪道 不能見如來
            </p>
            
            {/* 한글 번역 */}
            <p 
              className="text-2xl sm:text-3xl text-amber-50 leading-relaxed mb-4"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              "만약 나를 색(형상)으로 보려 하거나,<br />
              음성으로 찾으려 한다면,<br />
              그 사람은 삿된 길을 가고 있는 것이다.<br />
              그는 결코 여래를 볼 수 없다."
            </p>
            
            {/* 영문 번역 */}
            <p 
              className="text-lg sm:text-xl text-amber-200 leading-relaxed mb-6 italic"
              style={{ fontFamily: "'Noto Serif', serif" }}
            >
              "If you're trying to see me in colour,<br />
              or in voice, he's on a dead path;<br />
              he can never see the Buddha."
            </p>
            
            <cite className="text-amber-200 text-lg not-italic">
              - 법구경 -
            </cite>
          </blockquote>

          {/* CTA */}
          <a
            href="#"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-amber-900 font-semibold rounded-lg hover:bg-amber-50 transition-all transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            <i className="ri-book-2-line"></i>
            자료실에서 더 많은 경전 보기
          </a>
        </div>
      </div>
    </section>
  );
}